'use client';

import type { ReactNode } from 'react';
import { token } from '@terra/ui-styled-system';
import { Badge } from '../../components/badge';

type DomainScopePathScopeBadgeVariant =
  | 'allPaths'
  | 'partially'
  | 'allowlist'
  | 'blocklist';

type DomainScopePathScopeBadgeProps = {
  variant: DomainScopePathScopeBadgeVariant;
  children: ReactNode;
};

const pathScopeBadgeBackground: Record<
  DomainScopePathScopeBadgeVariant,
  string
> = {
  allPaths: token('colors.bg.neutral.muted'),
  partially: token('colors.bg.neutral.muted'),
  allowlist: token('colors.bg.neutral.success'),
  blocklist: token('colors.bg.neutral.error'),
};

export const DomainScopePathScopeBadge = ({
  variant,
  children,
}: DomainScopePathScopeBadgeProps) => (
  <Badge
    variant="fill"
    size="sm"
    bg={pathScopeBadgeBackground[variant]}
    color="fg.default"
    flexShrink={0}
  >
    {children}
  </Badge>
);
